import BaseModel from "./BaseModel";

class Role extends BaseModel {
    static route = "roles";
}

export default Role;
